// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   RiAddLine,
//   RiEditLine,
//   RiDeleteBinLine,
//   RiArrowLeftSLine,
//   RiArrowRightSLine,
//   RiCloseLine,
// } from "react-icons/ri";
// import toast from "react-hot-toast";
// import uploadToCloudinary from "../../utils/cloudinary";
// import Swal from "sweetalert2";
// import { confirmAndDelete } from "../../utils/confirmAndDelete";

// const SportCardSkeleton = () => (
//   <div className="bg-white rounded-2xl shadow-lg border  p-4 animate-pulse">
//     <div className="flex items-center mb-4">
//       <div className="w-10 h-10 bg-gray-200 rounded mr-3"></div>
//       <div className="h-5 bg-gray-200 rounded w-32"></div>
//     </div>
//     <div className="grid grid-cols-2 gap-2 mb-4">
//       <div className="h-24 bg-gray-200 rounded-lg"></div>
//       <div className="h-24 bg-gray-200 rounded-lg"></div>
//     </div>
//     <div className="space-y-2 mb-4">
//       <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//       <div className="h-4 bg-gray-200 rounded w-5/6"></div>
//     </div>
//     <div className="flex justify-end space-x-2">
//       <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
//       <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
//     </div>
//   </div>
// );

// const SportsCategories = () => {
//   const [sports, setSports] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingSport, setEditingSport] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [formData, setFormData] = useState({
//     name: "",
//     homeImageUrl: "",
//     iconImageUrl: "",
//     images: [""],
//     contents: [{ heading: "", description: "" }],
//   });

//   const sportsPerPage = 4;

//   // Fetch all sports categories
//   const fetchSports = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`
//       );
//       setSports(res.data.categories || []);
//     } catch (err) {
//       console.error(err);
//       setSports([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSports();
//   }, []);

//   const indexOfLast = currentPage * sportsPerPage;
//   const indexOfFirst = indexOfLast - sportsPerPage;
//   const currentSports = sports.slice(indexOfFirst, indexOfLast);

//   // --- Handle Form Fields ---
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   //  Unified handler for single file upload (icon or others)
//   const handleFileUpload = async (file, key = "imageUrl", index = null) => {
//     if (!file) return;

//     const toastId = toast.loading("Uploading image...");
//     try {
//       setUploading(true);
//       const uploadedUrl = await uploadToCloudinary(file);

//       if (key === "iconImageUrl") {
//         // For icon
//         setFormData({ ...formData, iconImageUrl: uploadedUrl });
//       } else if (key === "homeImageUrl") {
//         setFormData({ ...formData, homeImageUrl: uploadedUrl });
//       } else if (key === "images" && index !== null) {
//         // For multiple images
//         const updatedImages = [...formData.images];
//         updatedImages[index] = uploadedUrl;
//         setFormData({ ...formData, images: updatedImages });
//       }
//       toast.success("Image uploaded successfully!", { id: toastId });
//     } catch (err) {
//       console.error("Cloudinary upload failed:", err);
//       toast.error("Image upload failed", { id: toastId });
//     } finally {
//       setUploading(false);
//     }
//   };

//   const addImageFileField = () =>
//     setFormData({ ...formData, images: [...formData.images, ""] });

//   const removeImageField = (i) => {
//     const updated = formData.images.filter((_, idx) => idx !== i);
//     setFormData({ ...formData, images: updated });
//   };

//   const handleContentChange = (index, field, value) => {
//     const updated = [...formData.contents];
//     updated[index][field] = value;
//     setFormData({ ...formData, contents: updated });
//   };

//   const addContentField = () =>
//     setFormData({
//       ...formData,
//       contents: [...formData.contents, { heading: "", description: "" }],
//     });

//   const removeContentField = (i) => {
//     const updated = formData.contents.filter((_, idx) => idx !== i);
//     setFormData({ ...formData, contents: updated });
//   };

//   const openNewModal = () => {
//     setEditingSport(null);
//     setFormData({
//       name: "",
//       iconImageUrl: "",
//       images: [""],
//       contents: [{ heading: "", description: "" }],
//     });
//     setIsModalOpen(true);
//   };

//   const openEditModal = (sport) => {
//     setEditingSport(sport);
//     setFormData({
//       name: sport.name,
//       homeImageUrl: sport.homeImageUrl,
//       iconImageUrl: sport.iconImageUrl,
//       images: [...sport.images],
//       contents: [...sport.contents],
//     });
//     setIsModalOpen(true);
//   };

//   const deleteSport = async (_id) => {
//     const confirmed = await confirmAndDelete({
//       id: _id,
//       url: `${process.env.REACT_APP_API_URL}/sports-categories/delete-category`,
//     });

//     if (confirmed) {
//       // Update UI after delete
//       const updated = sports.filter((s) => s._id !== _id);
//       setSports(updated);

//       // Pagination fix
//       const totalPagesAfterDelete = Math.ceil(updated.length / sportsPerPage);
//       if (currentPage > totalPagesAfterDelete) {
//         setCurrentPage(totalPagesAfterDelete || 1);
//       }

//       // Success alert
//       Swal.fire({
//         icon: "success",
//         title: "Deleted!",
//         text: "The sport has been deleted successfully.",
//         confirmButtonColor: "#10B981",
//         background: "#fff",
//       });
//     } else {
//       console.error("Delete canceled or failed");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setIsSubmitting(true);
//       if (editingSport) {
//         await axios.put(
//           `${process.env.REACT_APP_API_URL}/sports-categories/edit-category/${editingSport._id}`,
//           formData
//         );
//       } else {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/sports-categories/create-category`,
//           formData
//         );
//       }
//       setIsModalOpen(false);
//       fetchSports();
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const totalPages = Math.ceil(sports.length / sportsPerPage);

//   return (
//     <div className="min-h-screen bg-transparent p-6 tracking-wide">
//       {/* Header */}
//       <div className="flex justify-between items-center mb-8">
//         <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent">
//           Sports Categories
//         </h1>
//         <button
//           onClick={openNewModal}
//           className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white py-2 px-4 rounded-xl flex items-center shadow-lg hover:shadow-xl transition-shadow"
//         >
//           <RiAddLine className="mr-2" />
//           New Category
//         </button>
//       </div>

//       {/* List */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
//         {loading
//           ? Array.from({ length: sportsPerPage }).map((_, i) => (
//               <SportCardSkeleton key={i} />
//             ))
//           : currentSports.map((sport) => (
//               <div
//                 key={sport._id}
//                 className="bg-white rounded-2xl max-h-[20rem] shadow-lg border border-primaryTextColor p-4 flex gap-4"
//               >
//                 {/* Left side - Home Image */}
//                 <div className="flex-shrink-0 w-[25%] flex items-stretch">
//                   <img
//                     src={sport.homeImageUrl}
//                     alt={`${sport.name}-home`}
//                     className="object-cover rounded-xl h-full"
//                   />
//                 </div>

//                 {/* Right side - Existing Card Content */}
//                 <div className="flex-1 flex flex-col h-full justify-around">
//                   <div className="flex items-center w-full justify-between mb-4">
//                     <div className="flex ">
//                       <img
//                         src={sport.iconImageUrl}
//                         alt={sport.name}
//                         className="w-6 h-6 mr-3"
//                       />
//                       <h2 className="text-lg font-bold text-primaryTextColor font-heading">
//                         {sport.name}
//                       </h2>
//                     </div>
//                     <div className="flex justify-end space-x-2 mt-auto">
//                       <button
//                         onClick={() => openEditModal(sport)}
//                         className="p-2 bg-gray-100 rounded-lg text-primaryBtnHoverColor hover:bg-primaryBtnColor hover:text-white"
//                       >
//                         <RiEditLine />
//                       </button>
//                       <button
//                         onClick={() => deleteSport(sport._id)}
//                         className="p-2 bg-gray-100 rounded-lg text-red-500 hover:bg-red-500 hover:text-white"
//                       >
//                         <RiDeleteBinLine />
//                       </button>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 gap-2 mb-4">
//                     {sport.images.map((img, i) => (
//                       <img
//                         key={i}
//                         src={img}
//                         alt={`${sport.name}-${i}`}
//                         className="h-24 w-full object-cover rounded-lg"
//                       />
//                     ))}
//                   </div>

//                   <div className="space-y-2 mb-2">
//                     {sport.contents.slice(0, 1).map((c, i) => (
//                       <div key={i}>
//                         <h3 className="font-semibold text-secondaryTextColor">
//                           {c.heading}
//                         </h3>
//                         <p className="text-sm text-gray-600 line-clamp-2">
//                           {c.description}
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-center items-center space-x-4">
//           <button
//             onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//             className={`p-2 rounded-lg ${
//               currentPage === 1
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
//             }`}
//           >
//             <RiArrowLeftSLine size={20} />
//           </button>
//           {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPage(page)}
//               className={`px-3 py-1 rounded-lg ${
//                 currentPage === page
//                   ? "bg-primaryBtnColor text-white"
//                   : "bg-gray-200 text-secondaryTextColor hover:bg-gray-300"
//               }`}
//             >
//               {page}
//             </button>
//           ))}
//           <button
//             onClick={() =>
//               currentPage < totalPages && setCurrentPage(currentPage + 1)
//             }
//             disabled={currentPage === totalPages}
//             className={`p-2 rounded-lg ${
//               currentPage === totalPages
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
//             }`}
//           >
//             <RiArrowRightSLine size={20} />
//           </button>
//         </div>
//       )}

//       {/* Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl w-full max-w-2xl border border-primaryTextColor shadow-xl max-h-[90vh] overflow-y-auto">
//             {/* Header */}
//             <div className="flex justify-between items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
//               <h2 className="text-xl font-bold text-primaryTextColor">
//                 {editingSport ? "Edit Sport" : "Add New Sport"}
//               </h2>
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="text-gray-500 hover:text-primaryBtnHoverColor"
//               >
//                 <RiCloseLine size={24} />
//               </button>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleSubmit} className="p-6 space-y-4">
//               {/* Sport Name */}
//               <div>
//                 <label className="block text-sm mb-2">Sport Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                   required
//                 />
//               </div>

//               {/* Icon Image */}
//               <div>
//                 <label className="block text-sm mb-2">Icon Image</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) =>
//                     handleFileUpload(e.target.files[0], "iconImageUrl")
//                   }
//                   className="w-full border border-gray-300 rounded-lg p-2 mb-2"
//                 />
//                 {formData.iconImageUrl && (
//                   <img
//                     src={formData.iconImageUrl}
//                     alt="Icon Preview"
//                     className="w-16 h-16 object-cover rounded-lg"
//                   />
//                 )}
//               </div>
//               {/* Home Image */}
//               <div>
//                 <label className="block text-sm mb-2">Home Image</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) =>
//                     handleFileUpload(e.target.files[0], "homeImageUrl")
//                   }
//                   className="w-full border border-gray-300 rounded-lg p-2 mb-2"
//                 />
//                 {formData.homeImageUrl && (
//                   <img
//                     src={formData.homeImageUrl}
//                     alt="Home-Image Preview"
//                     className="w-16 h-16 object-cover rounded-lg"
//                   />
//                 )}
//               </div>

//               {/* Gallery Images */}
//               <div>
//                 <label className="block text-sm mb-2">Gallery Images</label>
//                 {formData.images.map((img, i) => (
//                   <div key={i} className="flex items-center mb-2">
//                     <input
//                       type="file"
//                       accept="image/*"
//                       onChange={(e) =>
//                         handleFileUpload(e.target.files[0], "images", i)
//                       }
//                       className="flex-1 border border-gray-300 rounded-lg p-2 mr-2"
//                     />
//                     {img && (
//                       <img
//                         src={img}
//                         alt={`Preview-${i}`}
//                         className="w-16 h-16 object-cover rounded-lg mr-2"
//                       />
//                     )}
//                     {formData.images.length > 1 && (
//                       <button
//                         type="button"
//                         onClick={() => removeImageField(i)}
//                         className="bg-red-500 text-white px-3 py-1 rounded-lg"
//                       >
//                         Remove
//                       </button>
//                     )}
//                   </div>
//                 ))}
//                 <button
//                   type="button"
//                   onClick={addImageFileField}
//                   className="bg-gray-200 text-secondaryTextColor px-3 py-1 rounded-lg hover:bg-gray-300"
//                 >
//                   + Add Image
//                 </button>
//               </div>

//               {/* Contents */}
//               <div>
//                 <label className="block text-sm mb-2">Contents</label>
//                 {formData.contents.map((c, i) => (
//                   <div key={i} className="mb-3">
//                     <input
//                       type="text"
//                       placeholder="Heading"
//                       value={c.heading}
//                       onChange={(e) =>
//                         handleContentChange(i, "heading", e.target.value)
//                       }
//                       className="w-full border border-gray-300 rounded-lg p-2 mb-2"
//                     />
//                     <textarea
//                       placeholder="Description"
//                       value={c.description}
//                       onChange={(e) =>
//                         handleContentChange(i, "description", e.target.value)
//                       }
//                       className="w-full border border-gray-300 rounded-lg p-2"
//                     />
//                     {formData.contents.length > 1 && (
//                       <button
//                         type="button"
//                         onClick={() => removeContentField(i)}
//                         className="bg-red-500 text-white px-3 py-1 rounded-lg mt-1"
//                       >
//                         Remove Section
//                       </button>
//                     )}
//                   </div>
//                 ))}
//                 <button
//                   type="button"
//                   onClick={addContentField}
//                   className="bg-gray-200 text-secondaryTextColor px-3 py-1 rounded-lg hover:bg-gray-300"
//                 >
//                   + Add Section
//                 </button>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex justify-end space-x-3">
//                 <button
//                   type="button"
//                   onClick={() => setIsModalOpen(false)}
//                   className="bg-gray-200 text-secondaryTextColor py-2 px-4 rounded-lg hover:bg-gray-300"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   disabled={uploading || isSubmitting}
//                   type="submit"
//                   className="bg-primaryBtnColor text-white  w-40 flex items-center justify-center py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
//                 >
//                   {isSubmitting ? (
//                     <div class="spinner w-full"></div>
//                   ) : editingSport ? (
//                     "Update Sport"
//                   ) : (
//                     "Add Sport"
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SportsCategories;

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  RiAddLine,
  RiEditLine,
  RiDeleteBinLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiCloseLine,
} from "react-icons/ri";
import toast from "react-hot-toast";
import uploadToCloudinary from "../../utils/cloudinary";
import Swal from "sweetalert2";
import { confirmAndDelete } from "../../utils/confirmAndDelete";

const SportCardSkeleton = () => (
  <div className="bg-white rounded-2xl shadow-lg border p-4 animate-pulse">
    <div className="flex items-center mb-4">
      <div className="w-10 h-10 bg-gray-200 rounded mr-3"></div>
      <div className="h-5 bg-gray-200 rounded w-32"></div>
    </div>
    <div className="grid grid-cols-2 gap-2 mb-4">
      <div className="h-24 bg-gray-200 rounded-lg"></div>
      <div className="h-24 bg-gray-200 rounded-lg"></div>
    </div>
    <div className="space-y-2 mb-4">
      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      <div className="h-4 bg-gray-200 rounded w-5/6"></div>
    </div>
    <div className="flex justify-end space-x-2">
      <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
      <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
    </div>
  </div>
);

const SportsCategories = () => {
  const [sports, setSports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingSport, setEditingSport] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPrograms, setShowPrograms] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    homeImageUrl: "",
    iconImageUrl: "",
    images: [""],
    contents: [{ heading: "", description: "" }],
    programs: [],
  });

  const sportsPerPage = 4;

  const availableEmojis = [
    "⭐",
    "🔥",
    "🏆",
    "⚡",
    "🎯",
    "💪",
    "🌟",
    "✨",
    "🏅",
    "🎖️",
    "💥",
    "🚀",
    "🎉",
    "💫",
    "💎",
    "🧠",
    "🏁",
    "🎊",
    "💯",
  ];

  const availableColors = [
    { name: "Purple", value: "purple" },
    { name: "Red", value: "red" },
    { name: "Green", value: "green" },
    { name: "Blue", value: "blue" },

    // Additional Tailwind colors
    { name: "Slate", value: "slate" },
    { name: "Gray", value: "gray" },
    { name: "Zinc", value: "zinc" },
    { name: "Neutral", value: "neutral" },
    { name: "Stone", value: "stone" },

    { name: "Orange", value: "orange" },
    { name: "Amber", value: "amber" },
    { name: "Yellow", value: "yellow" },
    { name: "Lime", value: "lime" },
    { name: "Emerald", value: "emerald" },
    { name: "Teal", value: "teal" },
    { name: "Cyan", value: "cyan" },
    { name: "Sky", value: "sky" },
    { name: "Indigo", value: "indigo" },
    { name: "Violet", value: "violet" },
    { name: "Fuchsia", value: "fuchsia" },
    { name: "Pink", value: "pink" },
    { name: "Rose", value: "rose" },
  ];

  const fetchSports = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`
      );
      setSports(res.data.categories || []);
    } catch (err) {
      console.error(err);
      setSports([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSports();
  }, []);

  const indexOfLast = currentPage * sportsPerPage;
  const indexOfFirst = indexOfLast - sportsPerPage;
  const currentSports = sports.slice(indexOfFirst, indexOfLast);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileUpload = async (file, key = "imageUrl", index = null) => {
    if (!file) return;

    const toastId = toast.loading("Uploading image...");
    try {
      setUploading(true);
      const uploadedUrl = await uploadToCloudinary(file);

      if (key === "iconImageUrl") {
        setFormData({ ...formData, iconImageUrl: uploadedUrl });
      } else if (key === "homeImageUrl") {
        setFormData({ ...formData, homeImageUrl: uploadedUrl });
      } else if (key === "images" && index !== null) {
        const updatedImages = [...formData.images];
        updatedImages[index] = uploadedUrl;
        setFormData({ ...formData, images: updatedImages });
      }
      toast.success("Image uploaded successfully!", { id: toastId });
    } catch (err) {
      console.error("Cloudinary upload failed:", err);
      toast.error("Image upload failed", { id: toastId });
    } finally {
      setUploading(false);
    }
  };

  const addImageFileField = () =>
    setFormData({ ...formData, images: [...formData.images, ""] });

  const removeImageField = (i) => {
    const updated = formData.images.filter((_, idx) => idx !== i);
    setFormData({ ...formData, images: updated });
  };

  const handleContentChange = (index, field, value) => {
    const updated = [...formData.contents];
    updated[index][field] = value;
    setFormData({ ...formData, contents: updated });
  };

  const addContentField = () =>
    setFormData({
      ...formData,
      contents: [...formData.contents, { heading: "", description: "" }],
    });

  const removeContentField = (i) => {
    const updated = formData.contents.filter((_, idx) => idx !== i);
    setFormData({ ...formData, contents: updated });
  };

  const handleProgramChange = (index, field, value) => {
    const updated = [...formData.programs];
    updated[index][field] = value;
    setFormData({ ...formData, programs: updated });
  };

  const handleProgramScheduleChange = (progIdx, schedIdx, field, value) => {
    const updated = [...formData.programs];
    updated[progIdx].schedule[schedIdx][field] = value;
    setFormData({ ...formData, programs: updated });
  };

  const handleProgramPricingChange = (progIdx, priceIdx, field, value) => {
    const updated = [...formData.programs];
    if (field === "popular") {
      updated[progIdx].pricing[priceIdx][field] = value === "true";
    } else {
      updated[progIdx].pricing[priceIdx][field] = value;
    }
    setFormData({ ...formData, programs: updated });
  };

  const handleProgramFeatureChange = (progIdx, featIdx, value) => {
    const updated = [...formData.programs];
    updated[progIdx].features[featIdx] = value;
    setFormData({ ...formData, programs: updated });
  };

  const addProgram = () => {
    const newProgram = {
      level: "",
      icon: "⭐",
      tagline: "",
      description: "",
      intensity: "",
      duration: "",
      schedule: [{ days: "", time: "", age: "" }],
      pricing: [{ type: "", price: "", sessions: "", popular: false }],
      features: [""],
      color: "purple",
    };
    setFormData({ ...formData, programs: [...formData.programs, newProgram] });
  };

  const removeProgram = (i) => {
    const updated = formData.programs.filter((_, idx) => idx !== i);
    setFormData({ ...formData, programs: updated });
  };

  const addScheduleToProgram = (progIdx) => {
    const updated = [...formData.programs];
    updated[progIdx].schedule.push({ days: "", time: "", age: "" });
    setFormData({ ...formData, programs: updated });
  };

  const removeScheduleFromProgram = (progIdx, schedIdx) => {
    const updated = [...formData.programs];
    updated[progIdx].schedule = updated[progIdx].schedule.filter(
      (_, idx) => idx !== schedIdx
    );
    setFormData({ ...formData, programs: updated });
  };

  const addPricingToProgram = (progIdx) => {
    const updated = [...formData.programs];
    updated[progIdx].pricing.push({
      type: "",
      price: "",
      sessions: "",
      popular: false,
    });
    setFormData({ ...formData, programs: updated });
  };

  const removePricingFromProgram = (progIdx, priceIdx) => {
    const updated = [...formData.programs];
    updated[progIdx].pricing = updated[progIdx].pricing.filter(
      (_, idx) => idx !== priceIdx
    );
    setFormData({ ...formData, programs: updated });
  };

  const addFeatureToProgram = (progIdx) => {
    const updated = [...formData.programs];
    updated[progIdx].features.push("");
    setFormData({ ...formData, programs: updated });
  };

  const removeFeatureFromProgram = (progIdx, featIdx) => {
    const updated = [...formData.programs];
    updated[progIdx].features = updated[progIdx].features.filter(
      (_, idx) => idx !== featIdx
    );
    setFormData({ ...formData, programs: updated });
  };

  const openNewModal = () => {
    setEditingSport(null);
    setShowPrograms(false);
    setFormData({
      name: "",
      homeImageUrl: "",
      iconImageUrl: "",
      images: [""],
      contents: [{ heading: "", description: "" }],
      programs: [],
    });
    setIsModalOpen(true);
  };

  const openEditModal = (sport) => {
    setEditingSport(sport);
    setShowPrograms(sport.programs && sport.programs.length > 0);
    setFormData({
      name: sport.name,
      homeImageUrl: sport.homeImageUrl,
      iconImageUrl: sport.iconImageUrl,
      images: [...sport.images],
      contents: [...sport.contents],
      programs: sport.programs ? [...sport.programs] : [],
    });
    setIsModalOpen(true);
  };

  const deleteSport = async (_id) => {
    const confirmed = await confirmAndDelete({
      id: _id,
      url: `${process.env.REACT_APP_API_URL}/sports-categories/delete-category`,
    });

    if (confirmed) {
      const updated = sports.filter((s) => s._id !== _id);
      setSports(updated);

      const totalPagesAfterDelete = Math.ceil(updated.length / sportsPerPage);
      if (currentPage > totalPagesAfterDelete) {
        setCurrentPage(totalPagesAfterDelete || 1);
      }

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The sport has been deleted successfully.",
        confirmButtonColor: "#10B981",
        background: "#fff",
      });
    } else {
      console.error("Delete canceled or failed");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      const submitData = { ...formData };
      if (!showPrograms) {
        submitData.programs = [];
      }

      if (editingSport) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/sports-categories/edit-category/${editingSport._id}`,
          submitData
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/sports-categories/create-category`,
          submitData
        );
      }
      setIsModalOpen(false);
      fetchSports();
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const totalPages = Math.ceil(sports.length / sportsPerPage);

  return (
    <div className="min-h-screen bg-transparent p-6 tracking-wide">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent">
          Sports Categories
        </h1>
        <button
          onClick={openNewModal}
          className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white py-2 px-4 rounded-xl flex items-center shadow-lg hover:shadow-xl transition-shadow"
        >
          <RiAddLine className="mr-2" />
          New Category
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {loading
          ? Array.from({ length: sportsPerPage }).map((_, i) => (
              <SportCardSkeleton key={i} />
            ))
          : currentSports.map((sport) => (
              <div
                key={sport._id}
                className="bg-white rounded-2xl max-h-[20rem] shadow-lg border border-primaryTextColor p-4 flex gap-4"
              >
                <div className="flex-shrink-0 w-[25%] flex items-stretch">
                  <img
                    src={sport.homeImageUrl}
                    alt={`${sport.name}-home`}
                    className="object-cover rounded-xl h-full"
                  />
                </div>

                <div className="flex-1 flex flex-col h-full justify-around">
                  <div className="flex items-center w-full justify-between mb-4">
                    <div className="flex ">
                      <img
                        src={sport.iconImageUrl}
                        alt={sport.name}
                        className="w-6 h-6 mr-3"
                      />
                      <h2 className="text-lg font-bold text-primaryTextColor font-heading">
                        {sport.name}
                      </h2>
                    </div>
                    <div className="flex justify-end space-x-2 mt-auto">
                      <button
                        onClick={() => openEditModal(sport)}
                        className="p-2 bg-gray-100 rounded-lg text-primaryBtnHoverColor hover:bg-primaryBtnColor hover:text-white"
                      >
                        <RiEditLine />
                      </button>
                      <button
                        onClick={() => deleteSport(sport._id)}
                        className="p-2 bg-gray-100 rounded-lg text-red-500 hover:bg-red-500 hover:text-white"
                      >
                        <RiDeleteBinLine />
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2 mb-4">
                    {sport.images.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        alt={`${sport.name}-${i}`}
                        className="h-24 w-full object-cover rounded-lg"
                      />
                    ))}
                  </div>

                  <div className="space-y-2 mb-2">
                    {sport.contents.slice(0, 1).map((c, i) => (
                      <div key={i}>
                        <h3 className="font-semibold text-secondaryTextColor">
                          {c.heading}
                        </h3>
                        <p className="text-sm text-gray-600 line-clamp-2">
                          {c.description}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center space-x-4">
          <button
            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
            className={`p-2 rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
            }`}
          >
            <RiArrowLeftSLine size={20} />
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`px-3 py-1 rounded-lg ${
                currentPage === page
                  ? "bg-primaryBtnColor text-white"
                  : "bg-gray-200 text-secondaryTextColor hover:bg-gray-300"
              }`}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() =>
              currentPage < totalPages && setCurrentPage(currentPage + 1)
            }
            disabled={currentPage === totalPages}
            className={`p-2 rounded-lg ${
              currentPage === totalPages
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
            }`}
          >
            <RiArrowRightSLine size={20} />
          </button>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-2xl border border-primaryTextColor shadow-xl max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
              <h2 className="text-xl font-bold text-primaryTextColor">
                {editingSport ? "Edit Sport" : "Add New Sport"}
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-primaryBtnHoverColor"
              >
                <RiCloseLine size={24} />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              {/* Sport Name */}
              <div>
                <label className="block text-sm mb-2">Sport Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                  required
                />
              </div>

              {/* Icon Image */}
              <div>
                <label className="block text-sm mb-2">Icon Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleFileUpload(e.target.files[0], "iconImageUrl")
                  }
                  className="w-full border border-gray-300 rounded-lg p-2 mb-2"
                />
                {formData.iconImageUrl && (
                  <img
                    src={formData.iconImageUrl}
                    alt="Icon Preview"
                    className="w-16 h-16 object-cover rounded-lg"
                  />
                )}
              </div>

              {/* Home Image */}
              <div>
                <label className="block text-sm mb-2">Home Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleFileUpload(e.target.files[0], "homeImageUrl")
                  }
                  className="w-full border border-gray-300 rounded-lg p-2 mb-2"
                />
                {formData.homeImageUrl && (
                  <img
                    src={formData.homeImageUrl}
                    alt="Home-Image Preview"
                    className="w-16 h-16 object-cover rounded-lg"
                  />
                )}
              </div>

              {/* Gallery Images */}
              <div>
                <label className="block text-sm mb-2">Gallery Images</label>
                {formData.images.map((img, i) => (
                  <div key={i} className="flex items-center mb-2">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        handleFileUpload(e.target.files[0], "images", i)
                      }
                      className="flex-1 border border-gray-300 rounded-lg p-2 mr-2"
                    />
                    {img && (
                      <img
                        src={img}
                        alt={`Preview-${i}`}
                        className="w-16 h-16 object-cover rounded-lg mr-2"
                      />
                    )}
                    {formData.images.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeImageField(i)}
                        className="bg-red-500 text-white px-3 py-1 rounded-lg"
                      >
                        Remove
                      </button>
                    )}
                  </div>
                ))}
                <button
                  type="button"
                  onClick={addImageFileField}
                  className="bg-gray-200 text-secondaryTextColor px-3 py-1 rounded-lg hover:bg-gray-300"
                >
                  + Add Image
                </button>
              </div>

              {/* Contents */}
              <div>
                <label className="block text-sm mb-2">Contents</label>
                {formData.contents.map((c, i) => (
                  <div key={i} className="mb-3">
                    <input
                      type="text"
                      placeholder="Heading"
                      value={c.heading}
                      onChange={(e) =>
                        handleContentChange(i, "heading", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-lg p-2 mb-2"
                    />
                    <textarea
                      placeholder="Description"
                      value={c.description}
                      onChange={(e) =>
                        handleContentChange(i, "description", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-lg p-2"
                    />
                    {formData.contents.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeContentField(i)}
                        className="bg-red-500 text-white px-3 py-1 rounded-lg mt-1"
                      >
                        Remove Section
                      </button>
                    )}
                  </div>
                ))}
                <button
                  type="button"
                  onClick={addContentField}
                  className="bg-gray-200 text-secondaryTextColor px-3 py-1 rounded-lg hover:bg-gray-300"
                >
                  + Add Section
                </button>
              </div>

              {/* Programs Checkbox */}
              <div className="border-t pt-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={showPrograms}
                    onChange={(e) => setShowPrograms(e.target.checked)}
                    className="w-5 h-5 text-primaryBtnColor rounded focus:ring-primaryBtnColor"
                  />
                  <span className="text-sm font-semibold">
                    Add Programs/Packages
                  </span>
                </label>
              </div>

              {/* Programs Section */}
              {showPrograms && (
                <div className="border-t pt-4">
                  <div className="flex justify-between items-center mb-3">
                    <label className="block text-sm font-semibold">
                      Programs
                    </label>
                    <button
                      type="button"
                      onClick={addProgram}
                      className="bg-primaryBtnColor text-white px-3 py-1 rounded-lg hover:bg-primaryBtnHoverColor text-sm"
                    >
                      + Add Program
                    </button>
                  </div>

                  {formData.programs.map((program, progIdx) => (
                    <div
                      key={progIdx}
                      className="border border-gray-300 rounded-lg p-4 mb-4 bg-gray-50"
                    >
                      <div className="flex justify-between items-center mb-3">
                        <h4 className="font-semibold text-primaryTextColor">
                          Program {progIdx + 1}
                        </h4>
                        <button
                          type="button"
                          onClick={() => removeProgram(progIdx)}
                          className="bg-red-500 text-white px-2 py-1 rounded text-sm"
                        >
                          Remove Program
                        </button>
                      </div>

                      {/* Program Basic Fields */}
                      <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                          <label className="block text-xs mb-1">Level</label>
                          <input
                            type="text"
                            value={program.level}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "level",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                            placeholder="e.g., U-11"
                          />
                        </div>

                        <div>
                          <label className="block text-xs mb-1">Icon</label>
                          <select
                            value={program.icon}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "icon",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                          >
                            {availableEmojis.map((emoji) => (
                              <option key={emoji} value={emoji}>
                                {emoji}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-xs mb-1">Color</label>
                          <select
                            value={program.color}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "color",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                          >
                            {availableColors.map((color) => (
                              <option key={color.value} value={color.value}>
                                {color.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-xs mb-1">
                            Intensity
                          </label>
                          <input
                            type="text"
                            value={program.intensity}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "intensity",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                            placeholder="e.g., Low"
                          />
                        </div>

                        <div className="col-span-2">
                          <label className="block text-xs mb-1">Tagline</label>
                          <input
                            type="text"
                            value={program.tagline}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "tagline",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                            placeholder="e.g., Future Stars"
                          />
                        </div>

                        <div className="col-span-2">
                          <label className="block text-xs mb-1">Duration</label>
                          <input
                            type="text"
                            value={program.duration}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "duration",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                            placeholder="e.g., 90 mins/session"
                          />
                        </div>

                        <div className="col-span-2">
                          <label className="block text-xs mb-1">
                            Description
                          </label>
                          <textarea
                            value={program.description}
                            onChange={(e) =>
                              handleProgramChange(
                                progIdx,
                                "description",
                                e.target.value
                              )
                            }
                            className="w-full border border-gray-300 rounded p-2 text-sm"
                            placeholder="Program description"
                            rows="2"
                          />
                        </div>
                      </div>

                      {/* Schedule */}
                      <div className="mb-3">
                        <div className="flex justify-between items-center mb-2">
                          <label className="block text-xs font-semibold">
                            Schedule
                          </label>
                          <button
                            type="button"
                            onClick={() => addScheduleToProgram(progIdx)}
                            className="bg-blue-500 text-white px-2 py-1 rounded text-xs"
                          >
                            + Schedule
                          </button>
                        </div>
                        {program.schedule.map((sched, schedIdx) => (
                          <div
                            key={schedIdx}
                            className="grid grid-cols-3 gap-2 mb-2"
                          >
                            <input
                              type="text"
                              value={sched.days}
                              onChange={(e) =>
                                handleProgramScheduleChange(
                                  progIdx,
                                  schedIdx,
                                  "days",
                                  e.target.value
                                )
                              }
                              className="border border-gray-300 rounded p-2 text-sm"
                              placeholder="Days"
                            />
                            <input
                              type="text"
                              value={sched.time}
                              onChange={(e) =>
                                handleProgramScheduleChange(
                                  progIdx,
                                  schedIdx,
                                  "time",
                                  e.target.value
                                )
                              }
                              className="border border-gray-300 rounded p-2 text-sm"
                              placeholder="Time"
                            />
                            <div className="flex gap-1">
                              <input
                                type="text"
                                value={sched.age}
                                onChange={(e) =>
                                  handleProgramScheduleChange(
                                    progIdx,
                                    schedIdx,
                                    "age",
                                    e.target.value
                                  )
                                }
                                className="flex-1 border border-gray-300 rounded p-2 text-sm"
                                placeholder="Age"
                              />
                              {program.schedule.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    removeScheduleFromProgram(progIdx, schedIdx)
                                  }
                                  className="bg-red-500 text-white px-2 rounded text-xs"
                                >
                                  ×
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Pricing */}
                      <div className="mb-3">
                        <div className="flex justify-between items-center mb-2">
                          <label className="block text-xs font-semibold">
                            Pricing
                          </label>
                          <button
                            type="button"
                            onClick={() => addPricingToProgram(progIdx)}
                            className="bg-blue-500 text-white px-2 py-1 rounded text-xs"
                          >
                            + Pricing
                          </button>
                        </div>
                        {program.pricing.map((price, priceIdx) => (
                          <div
                            key={priceIdx}
                            className="grid grid-cols-4 gap-2 mb-2 items-start"
                          >
                            <input
                              type="text"
                              value={price.type}
                              onChange={(e) =>
                                handleProgramPricingChange(
                                  progIdx,
                                  priceIdx,
                                  "type",
                                  e.target.value
                                )
                              }
                              className="border border-gray-300 rounded p-2 text-sm"
                              placeholder="Type"
                            />
                            <input
                              type="text"
                              value={price.price}
                              onChange={(e) =>
                                handleProgramPricingChange(
                                  progIdx,
                                  priceIdx,
                                  "price",
                                  e.target.value
                                )
                              }
                              className="border border-gray-300 rounded p-2 text-sm"
                              placeholder="Price"
                            />
                            <input
                              type="text"
                              value={price.sessions}
                              onChange={(e) =>
                                handleProgramPricingChange(
                                  progIdx,
                                  priceIdx,
                                  "sessions",
                                  e.target.value
                                )
                              }
                              className="border border-gray-300 rounded p-2 text-sm"
                              placeholder="Sessions"
                            />
                            <div className="flex gap-1 items-center">
                              <label className="flex items-center text-xs">
                                <input
                                  type="checkbox"
                                  checked={price.popular}
                                  onChange={(e) =>
                                    handleProgramPricingChange(
                                      progIdx,
                                      priceIdx,
                                      "popular",
                                      e.target.checked.toString()
                                    )
                                  }
                                  className="mr-1"
                                />
                                Popular
                              </label>
                              {program.pricing.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    removePricingFromProgram(progIdx, priceIdx)
                                  }
                                  className="bg-red-500 text-white px-2 py-1 rounded text-xs"
                                >
                                  ×
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Features */}
                      <div>
                        <div className="flex justify-between items-center mb-2">
                          <label className="block text-xs font-semibold">
                            Features
                          </label>
                          <button
                            type="button"
                            onClick={() => addFeatureToProgram(progIdx)}
                            className="bg-blue-500 text-white px-2 py-1 rounded text-xs"
                          >
                            + Feature
                          </button>
                        </div>
                        {program.features.map((feature, featIdx) => (
                          <div key={featIdx} className="flex gap-2 mb-2">
                            <input
                              type="text"
                              value={feature}
                              onChange={(e) =>
                                handleProgramFeatureChange(
                                  progIdx,
                                  featIdx,
                                  e.target.value
                                )
                              }
                              className="flex-1 border border-gray-300 rounded p-2 text-sm"
                              placeholder="Feature description"
                            />
                            {program.features.length > 1 && (
                              <button
                                type="button"
                                onClick={() =>
                                  removeFeatureFromProgram(progIdx, featIdx)
                                }
                                className="bg-red-500 text-white px-2 py-1 rounded text-xs"
                              >
                                ×
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="mt-4 border-t pt-4">
                        <h1 className="font-semibold text-sm mb-3">
                          Program Navigation Button
                        </h1>

                        <div className="grid grid-cols-2 gap-3">
                          {/* Button Text */}
                          <div>
                            <label className="block text-xs mb-1">
                              Button Text
                            </label>

                            <select
                              value={program.button?.text || "Contact Us"}
                              onChange={(e) =>
                                handleProgramChange(progIdx, "button", {
                                  ...program.button,
                                  text: e.target.value,
                                })
                              }
                              className="w-full border border-gray-300 rounded p-2 text-sm"
                            >
                              <option value="Contact Us">Contact Us</option>
                              <option value="Register Now">Register Now</option>
                            </select>
                          </div>

                          {/* Button URL */}
                          <div>
                            <label className="block text-xs mb-1">
                              Button URL
                            </label>

                            <input
                              type="url"
                              value={program.button?.url || ""}
                              onChange={(e) =>
                                handleProgramChange(progIdx, "button", {
                                  ...program.button,
                                  url: e.target.value,
                                })
                              }
                              className="w-full border border-gray-300 rounded p-2 text-sm"
                              placeholder="https://example.com/register"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="bg-gray-200 text-secondaryTextColor py-2 px-4 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  disabled={uploading || isSubmitting}
                  type="submit"
                  className="bg-primaryBtnColor text-white w-40 flex items-center justify-center py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
                >
                  {isSubmitting ? (
                    <div className="spinner w-full"></div>
                  ) : editingSport ? (
                    "Update Sport"
                  ) : (
                    "Add Sport"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SportsCategories;
